
export interface IPasswordValidationRequirement {
    readonly type: string;
    isMatch(password: string): boolean;
}

export class RequireLength implements IPasswordValidationRequirement {
    type = 'min-length';

    constructor(minLength: number) {
        this.minLength = minLength;
    }

    readonly minLength: number;

    isMatch(password: string): boolean {
        return password.length >= this.minLength;
    }
}

export class RequireLowercase implements IPasswordValidationRequirement {
    type = 'lowercase';

    private readonly _regex: RegExp = /[a-z]/;
    isMatch(password: string): boolean {
        return this._regex.test(password);
    }
}

export class RequireUppercase implements IPasswordValidationRequirement {
    type = 'uppercase';

    private readonly _regex: RegExp = /[A-Z]/;
    isMatch(password: string): boolean {
        return this._regex.test(password);
    }
}

export class RequireNumber implements IPasswordValidationRequirement {
    type = 'number';
    private readonly _regex: RegExp = /[0-9]/;

    isMatch(password: string): boolean {
        return this._regex.test(password);
    }
}

class PasswordValidationResult {
    constructor(unmetRequirements: IPasswordValidationRequirement[]) {
        this.unmetRequirements = unmetRequirements;
        this.valid = unmetRequirements.length === 0;
    }

    readonly unmetRequirements: IPasswordValidationRequirement[];
    readonly valid: boolean;
}

export class PasswordValidator {
    constructor(requirements: IPasswordValidationRequirement[]) {
        this.requirements = [...requirements];
    }

    requirements: IPasswordValidationRequirement[];

    validate(password: string): PasswordValidationResult {
        const unmetRequirements: IPasswordValidationRequirement[] = [];

        for (const req of this.requirements) {
            if (!req.isMatch(password)) {
                unmetRequirements.push(req);
            }
        }
        return new PasswordValidationResult(unmetRequirements);
    }
}

export function getDefaultPasswordRequirements() {
    return [new RequireLength(8), new RequireLowercase(), new RequireUppercase(), new RequireNumber()];
}